"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leitungJson = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const LeitungCategory_1 = require("./LeitungCategory");
const LeitungModel_1 = require("./LeitungModel");
const LeitungslaengeUeberstandLock_1 = require("./LeitungslaengeUeberstandLock");
exports.leitungJson = {
    EntityId: '1508923396598_22991',
    Id: 33036,
    ArtNr: { DE: 'CF5.07.03', US: 'CF5-07-03' },
    ArtNrExists: true,
    ArtNrGenerated: 'CF5.07.03',
    Bezeichnung: {
        'de-DE': 'chainflex® CF5 Steuerleitung PVC',
        'hu-HU': 'chainflex® CF5 PVC vezérlőkábel',
        'en-US': 'chainflex® CF5 control cable PVC',
        'zh-TW': 'chainflex® CF5 PVC控制電纜',
        'ko-KR': 'Chainflex® CF5 컨트롤 케이블 PVC',
        'es-ES': 'Cable de mando chainflex® CF5.UL PVC',
        'zh-CN': 'chainflex® CF5 PVC控制电缆',
        'it-IT': 'chainflex® CF5 cavo di comando PVC',
        'pl-PL': 'Przewód sterujący chainflex® CF5 z PCV',
        'nl-NL': 'chainflex® CF5 stuurstroomkabel PVC',
        'pt-PT': 'chainflex® CF5 - Cabo de Comando em PVC',
        'sv-SE': 'chainflex® CF5 PVC-styrkabel',
        'da-DK': 'PVC-kontrolkabel chainflex® CF5',
        'cs-CZ': 'Ovládací kabel chainflex® CF5 z PVC',
        'fr-FR': 'Câble de commandes chainflex® CF5 PVC',
        'en-GB': 'chainflex® CF5 control cable PVC',
        'ja-JP': 'チェーンフレックスCF5 制御ケーブル PVC外被',
    },
    Beschriftung: LeitungModel_1.LeitungBeschriftung.keine,
    Aussendurchmesser: { Unit: 'mm', Value: 6.5 },
    Kupferzahl: { Unit: 'kg_km', Value: 24 },
    Leitungsaufbau: { 'de-DE': '3G0,75' },
    Leitungslaenge: { Unit: 'mm', Value: 2214 },
    LaengeUeberstandLock: LeitungslaengeUeberstandLock_1.LeitungslaengeUeberstandLock.none,
    GewichtKgProKm: { Unit: 'kg_km', Value: 56 },
    BiegeradiusMin: { Unit: 'mm', Value: 44.199999999999996 },
    FesteLaenge: false,
    UeberstandFestpunkt: { Unit: 'mm', Value: 25 },
    UeberstandMitnehmer: { Unit: 'mm', Value: 25 },
    RAL_Nummer: '6005',
    Categories: [LeitungCategory_1.LeitungCategory.ControlCables],
    LocalTransform: [1, 0, 0, 1, 21.586790084838867, 11.512377738952637],
    IAIndex: '1',
    Aderzahl: '0',
    AkeneoSku: '',
    ArticleSpecs: [],
    AuhiGleitend: false,
    AuhiTemperaturMax: {
        Unit: 'K',
        Value: 111,
    },
    AuhiTemperaturMin: {
        Unit: 'K',
        Value: 11,
    },
    DESINA: false,
    DiscontinuedModel: false,
    DNV_GL: false,
    DataSource: 'mix',
    EAC: false,
    EchainId: 'mocked-id!',
    Flammwidrig: false,
    FreigabeECF: false,
    FreigabeEIC: false,
    FreigabeEIQ: false,
    FreigabeEKE: false,
    FreitragenderBetriebErlaubt: false,
    Gesamtschirm: false,
    HaengenderBetriebErlaubt: false,
    Halogenfrei: false,
    Kuehlmittelbestaendig: false,
    MUDBestaendig: false,
    MainCategory: LeitungCategory_1.LeitungCategory.ControlCables,
    Mantelwerkstoff: echain_product_models_1.Mantelwerkstoff.PUR,
    Oelbestaendigkeit: echain_product_models_1.OelBestaendigkeit.Class1,
    Querschnitt: {},
    Reinraum: false,
    Schirmung: false,
    Torsionsfaehig: false,
    TwistedPair: false,
    UL_CSA: false,
    UVBestaendigkeit: echain_product_models_1.UvBestaendigkeit.Gering,
    Ungeschirmt: false,
    HatStecker: false,
};
//# sourceMappingURL=leitungJson.js.map